// hooks.
import { useUserLeadDetail } from "@shared/hooks/userLeadDetail.hook";
import { useGetPublicationPriceInfo } from "../pricing/pricing.hooks";
import { useGetHistoryLeadInfo } from "../historyLeadInfo/historyLeadInfo.hooks";
import { mapComparablesForPricing } from "../historyLeadInfo/mapComparablesForPricing";
import { useGetValidateTopeQuery } from "./limitPrice.endpoints";

export const useValidateTope = ({ price }: { price?: number }) => {
  const { country, area, medianZone, medianZoneId } = useUserLeadDetail();

  const {
    getPublicationPriceInfoQuery: { data },
  } = useGetPublicationPriceInfo();

  const {
    getHistoryLeadInfoQuery: { data: historyLeadInfo },
  } = useGetHistoryLeadInfo();

  const comparableInfoUsed = mapComparablesForPricing(
    historyLeadInfo?.used_comparables,
  );

  const comparableToJsonString = JSON.stringify(comparableInfoUsed);
  const comparableToEncodedString = encodeURIComponent(comparableToJsonString);

  const category = data?.categoryPriceName;
  const finalMedianZone = country === "MX" ? medianZone : medianZoneId;

  const shouldFetch =
    !!price &&
    !!country &&
    !!area &&
    !!finalMedianZone &&
    comparableToEncodedString !== null;

  const getValidateTopeQuery = useGetValidateTopeQuery(
    {
      area,
      category,
      comparables: comparableToEncodedString,
      country,
      medianZone: finalMedianZone,
      price,
    },
    {
      skip: !shouldFetch,
    },
  );

  return { getValidateTopeQuery };
};
